import React from 'react';
import { Flex } from 'antd';

import { Page } from 'shared/ui/Page';

import { PageHeader } from '../widgets/PageHeader';
import { TabSwitcher } from '../components/TabSwitcher';
import { PageContent } from '../widgets/PageContent';

export const AnalyticsPage = () => {
    return (
        <Page title='Аналитика'>
            <TabSwitcher />
            <Flex gap={24} vertical>
                <PageHeader />
                <PageContent />
            </Flex>
        </Page>
    );
};
